import { cn } from "../../../utils/styles";
import { DocumentName } from "./DocumentName";
import { FileStatus } from "../../atom/FileStatus";
import { DocumentActions } from "./DocumentActions";
import React from "react";
import { ParticipantFile } from "../../../types/components";
import { bytesToKilobytes } from "../../../utils/file";
import { useTranslation } from "react-i18next";

interface DocumentsTableProps {
  data?: ParticipantFile[] | null;
  setCurrentFile: React.Dispatch<React.SetStateAction<ParticipantFile | null>>;
  setIsRemoveModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setIsUploadModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

export const DocumentsTable: React.FC<DocumentsTableProps> = ({
  data,
  setCurrentFile,
  setIsRemoveModalOpen,
  setIsUploadModalOpen,
}) => {
  const { t } = useTranslation();

  return (
    <table>
      <thead>
        <tr className="font-light text-[16px] h-11 leading-[100%] text-gray-550 border-b border-gray-200">
          <td className="py-3 px-6 w-[520px]">{t("File name")}</td>
          <td className="py-3 px-6 w-[120px]">{t("File size")}</td>
          <td className="py-3 px-6 w-[200px]">{t("Supported file types")}</td>
          <td className="py-3 px-6 w-[200px]">{t("Status")}</td>
          <td className="py-3 px-6 w-[176px]"></td>
        </tr>
      </thead>
      <tbody>
        {data?.map(({ id, type, status, file, comment }, index) => (
          <tr key={id} className={cn("", index !== data?.length - 1 && "border-b border-gray-100")}>
            <td className="px-6 py-4 w-[520px] h-[96px]">
              <DocumentName
                name={type?.name}
                description={type?.description}
                file_type={file?.file_type}
                optional={type?.is_mandatory === false}
              />
            </td>
            <td className="py-4 px-6 w-[120px]">
              <p className="text-[16px]">{bytesToKilobytes(file?.file_size ?? 0)} KB</p>
            </td>
            <td className="py-4 px-6 w-[200px]">
              <p className="text-[16px]">{type?.allowed_file_types?.toUpperCase()}</p>
            </td>
            <td className="py-4 px-6 w-[200px]">
              <FileStatus comment={comment} code={status?.code} />
            </td>
            <td className="py-4 px-6 w-[176px]">
              <DocumentActions
                participantFile={data[index]}
                code={status?.code}
                setCurrentFile={setCurrentFile}
                typeCode={type?.code}
                setIsRemoveModalOpen={setIsRemoveModalOpen}
                setIsUploadModalOpen={setIsUploadModalOpen}
              />
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};
